import { HasVariablesInGit } from "@octopusdeploy/octopus-server-client";
import type React from "react";
import { BranchAwareRedirect } from "./BranchAwareRedirect";
export function VariablesBranchAwareRedirect({ children }: React.PropsWithChildren<{}>) {
    return <BranchAwareRedirect condition={(project) => HasVariablesInGit(project.PersistenceSettings)}>{children}</BranchAwareRedirect>;
}
